export const GET_NAVIGATION_STATUS = 'GET_NAVIGATION_STATUS'
export const SET_NAVIGATION_STATUS = 'SET_NAVIGATION_STATUS'

export const getNavigationStatus = () => {
  return {
    type: GET_NAVIGATION_STATUS
  }
}

export const setNavigationStatus = (status) => {
  return {
    type: SET_NAVIGATION_STATUS,
    status
  }
}
